<script>
  import { createEventDispatcher } from "svelte";
  export let type = "pdf"; // 'pdf' | 'image'
  const dispatch = createEventDispatcher();
  let dragOver = false;
  let fileInput;
  let accept = type === "pdf" ? "application/pdf" : "image/*";
  const labelText = type === "pdf" ? "PDF" : "Image";

  function onDrop(e) {
    e.preventDefault();
    dragOver = false;
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) dispatch("file", file);
  }
  function onFileChange() {
    const file = fileInput.files && fileInput.files[0];
    if (file) dispatch("file", file);
    fileInput.value = null;
  }
</script>

<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
  on:click={() => dispatch("close")}
  on:dragover|preventDefault={e => (dragOver = true)}
  on:dragleave={() => (dragOver = false)}
  on:drop|preventDefault={onDrop}>
  <div
    class="bg-white rounded-lg shadow-2xl w-full max-w-lg p-6"
    on:click|stopPropagation>
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-xl font-bold text-gray-800">
        {type === "pdf" ? "Upload PDF" : "Add Image"}
      </h2>
      <button
        on:click={() => dispatch("close")}
        class="text-gray-400 hover:text-gray-600 text-3xl leading-none"
        aria-label="Close">&times;</button>
    </div>

    <input
      bind:this={fileInput}
      type="file"
      accept={accept}
      class="hidden"
      on:change={onFileChange} />

    <div
      class="flex flex-col items-center justify-center border-2 border-dashed rounded-lg p-10 cursor-pointer text-center transition-colors duration-200"
      class:border-blue-500={dragOver}
      class:bg-blue-50={dragOver}
      class:border-gray-300={!dragOver}
      on:dragover|preventDefault={e => (dragOver = true)}
      on:dragleave={() => (dragOver = false)}
      on:drop|preventDefault={onDrop}
      on:click={() => fileInput.click()}>
      <svg
        class="w-12 h-12 text-gray-400"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
      </svg>
      <p class="mt-4 text-gray-600">
        Drag &amp; drop your {labelText} here
      </p>
      <p class="text-sm text-gray-400 mt-1">or</p>
      <span
        class="mt-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded">
        Choose from file
      </span>
    </div>
  </div>
</div>
